<template>
  <div class="container">
    <vs-card title="Modelos de Riesgo">
      <vs-table :data="groups">
        <template slot="thead">
          <vs-th>Grupo</vs-th>
          <vs-th>Peso categoría</vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr v-for="group in data">
            <vs-td>
              <router-link :to="`/risk-model/admin/1/groups/${group.id}/rules`">
                {{ group.name }}
              </router-link>
            </vs-td>
            <vs-td>{{group.weight}} %</vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-card>
  </div>
</template>

<script>
import {RiskModel} from "@/services/ModelRisk/RiskModel";

export default {
  name: "Versions",
  data: () => ({
    groups: []
  }),
  async mounted() {
    this.groups = await RiskModel.catalog()
      .all()
  }
}
</script>

<style scoped>

</style>
